document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-faq-content]');
  if (!container) return;

  var questions = container.querySelectorAll('h2');
  questions.forEach(function (question) {
    var body = [];
    var node = question.nextElementSibling;
    while (node && node.tagName !== 'H2' && node.tagName !== 'H1') {
      body.push(node);
      node = node.nextElementSibling;
    }

    var details = document.createElement('details');
    details.className = 'faq-item';
    var summary = document.createElement('summary');
    summary.textContent = question.textContent.trim();
    details.appendChild(summary);
    body.forEach(function (el) {
      details.appendChild(el);
    });

    question.replaceWith(details);
  });
});
